module.exports = __webpack_public_path__ + "static/media/guide_Page_11.42a50c78.png";